import React from "react";

export default function YellowLine() {
    return (
        <div
            style={{
                width: "100%",
                height: "3px",
            }}
            className='gold-bg-gradient'
        />
    );
}
